import type { SliceStateFromReducer } from 'shared/types';

import type { productSlice } from './product.slice';

export type TOffersStateFromReducer = SliceStateFromReducer<typeof productSlice>;

export const productSelector = (state: TOffersStateFromReducer) => state?.product?.product;
